import { Theme } from "../../../components/constants";

export default {
    grid: { 
        padding: '30px 100px' 
    },
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    actionsRow: { 
        display: 'flex', 
        gap: '20px' 
    },
    checkBox: { 
        display: 'flex', 
        alignItems: 'center', 
        gap: '15px' 
    },
    refColor: {
        color: '#257cc3'
    },
    linkHover: {
        cursor: 'pointer'
    }
}